module.exports = __webpack_public_path__ + "static/media/footer-logo.c1b5e9af.svg";